export default __webpack_public_path__ + "static/media/Logo.658f9872.svg";